var exports = {
  "container": "container__ZwXmIS",
  "customColor": "customColor__if51LG",
  "hasBackground": "hasBackground__BLby9-",
  "auburn": "auburn__aRwn-V",
  "blue": "blue__her2sM",
  "brown": "brown__XYQBr8",
  "coral": "coral___0FYdr",
  "cyan": "cyan__bZNjev",
  "gray": "gray__2SnaqV",
  "green": "green__hNR7Jg",
  "indigo": "indigo__Rt_BSc",
  "lemon": "lemon__CTSbqB",
  "lime": "lime__JTk9lH",
  "olive": "olive__i4vEQY",
  "orange": "orange__e_yL4t",
  "pine": "pine__e238eH",
  "pink": "pink__86aHsg",
  "plum": "plum__JvgHDx",
  "purple": "purple__xjhn_H",
  "red": "red__dkxsCt",
  "teal": "teal__7ZcjLX",
  "yellow": "yellow__aI-Gui",
};

__webpack_require__.r(module.exports = exports);
